module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/_cache/tech-3.vue");


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/tech.md
// module id = 216
// module chunks = 0